export default __webpack_public_path__ + "static/media/ActiveUploads.62b657f2.svg";